import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "exclamation",
  "use": "exclamation-usage",
  "viewBox": "0 0 3 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 3 15\" id=\"exclamation\"><path fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"nonzero\" d=\"M.7 11L0 3.5V0h3v3.5L2.3 11H.7zm.8 4a1.5 1.5 0 110-3 1.5 1.5 0 010 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol